import styled from "styled-components";
import { useHistory } from "react-router-dom";
import CardHeader from "../CardHeader/CardHeader";
import CustomButton from "../CustomButton/CustomButton";
import theme from "../../theme/theme";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin-top: 7%;
  }

  .buttonContainer {
    text-align: right;
    margin-top: 7%;
  }

  .disclaimer {
    width: 100%;
    text-align: left;
    margin-top: 4%;
  }

  .linkButton {
    text-decoration: underline;
    color: ${theme.colors.primaryStrong};
    font-weight: 700;
    cursor: pointer;
  }
`;

const PasswordChangeConfirmation = () => {
  const history = useHistory();

  const handleLoginClick = () => {
    history.push("/login");
  };

  return (
    <BodyWrapper>
      <CardHeader text={"Your Password Has Been Changed"} />
      <div className="buttonContainer">
        <CustomButton text={"Login"} onClick={handleLoginClick} />
      </div>
    </BodyWrapper>
  );
};

export default PasswordChangeConfirmation;
